import { useId, useRef } from 'react'
import GlassOverlay from './GlassOverlay'
import './ConfirmModal.css'

function TrashGlyph() {
  return (
    <svg viewBox="0 0 24 24" width="28" height="28" aria-hidden="true">
      <path
        d="M5 7h14M10 7V5h4v2M8 7l.7 12h6.6L16 7"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

function CloseGlyph() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
      <path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  )
}

function ConfirmGlyph() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
      <path d="M5 12l5 5 9-10" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default function ConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  subject = '',
  description = '',
  variant = 'default',
  busy = false,
  error = '',
  confirmLabel = 'Confirmer',
  cancelLabel = 'Annuler',
  zIndex = 1400,
}) {
  const cancelRef = useRef(null)
  const titleId = useId()
  const copyId = useId()
  const isDelete = variant === 'delete'
  const heading = title || (isDelete ? 'Supprimer ce produit ?' : 'Confirmation')
  const detail = description || message || (isDelete
    ? 'Le produit sera retiré de ce panier. Cette action ne peut pas être annulée.'
    : '')

  const viewRef = useRef({
    heading,
    subject,
    detail,
    error,
    isDelete,
    confirmLabel,
    cancelLabel,
    busy,
  })
  if (isOpen) {
    viewRef.current = {
      heading,
      subject,
      detail,
      error,
      isDelete,
      confirmLabel,
      cancelLabel,
      busy,
    }
  }
  const view = viewRef.current

  const handleCancel = () => {
    if (view.busy) return
    onClose?.()
  }

  const handleConfirm = () => {
    if (view.busy) return
    onConfirm?.()
  }

  return (
    <GlassOverlay
      isOpen={isOpen}
      onClose={handleCancel}
      closeOnBackdrop
      closeOnEscape
      allowClose={!view.busy}
      labelledBy={titleId}
      describedBy={copyId}
      panelClassName={`confirm-modal${view.isDelete ? ' is-delete' : ''}`}
      initialFocusRef={cancelRef}
      zIndex={zIndex}
    >
      <div className="confirm-modal-layout">
        <div className={`confirm-modal-icon${view.isDelete ? ' is-danger' : ''}`} aria-hidden="true">
          {view.isDelete ? <TrashGlyph /> : <ConfirmGlyph />}
        </div>
        <h2 id={titleId}>{view.heading}</h2>
        {view.subject ? <p className="confirm-modal-subject">{view.subject}</p> : null}
        {view.detail ? <p id={copyId} className="confirm-modal-copy">{view.detail}</p> : <p id={copyId} className="visually-hidden">Confirmation</p>}
        {view.error ? <p className="confirm-modal-error" role="alert">{view.error}</p> : null}
        <div className="confirm-modal-actions">
          <button
            ref={cancelRef}
            type="button"
            className="confirm-modal-icon-btn"
            onClick={handleCancel}
            disabled={view.busy}
            aria-label={view.cancelLabel}
            title={view.cancelLabel}
          >
            <CloseGlyph />
          </button>
          <button
            type="button"
            className={`confirm-modal-icon-btn${view.isDelete ? ' is-danger' : ''}${view.busy ? ' is-busy' : ''}`}
            onClick={handleConfirm}
            disabled={view.busy}
            aria-label={view.busy ? 'Suppression en cours' : view.confirmLabel}
            title={view.busy ? 'Suppression en cours' : view.confirmLabel}
            aria-busy={view.busy || undefined}
          >
            {view.busy ? <span className="confirm-modal-spinner" aria-hidden="true" /> : (view.isDelete ? <TrashGlyph /> : <ConfirmGlyph />)}
          </button>
        </div>
      </div>
    </GlassOverlay>
  )
}
